var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "header-box", attrs: { span: 24 } },
    [
      _c(
        "el-col",
        {
          staticClass: "logo",
          class: { logo__special: _vm.specialChannel },
          attrs: { span: _vm.specialChannel ? 4 : 16 }
        },
        [
          _c("span", { staticClass: "header-box__title" }, [
            _vm.customInfo
              ? _c("img", {
                  staticClass: "cloud__image",
                  attrs: {
                    src:
                      _vm.customInfo &&
                      (_vm.customInfo.logo ||
                        "/static/" + _vm.customInfo.subdomain + "/logo.png"),
                    alt: ""
                  }
                })
              : _c("img", {
                  staticClass: "cloud__image default__image",
                  attrs: {
                    src: require("@/assets/images/feiche@2x.png"),
                    alt: ""
                  }
                }),
            _vm._v(
              "\n      " + _vm._s(_vm.collapsed ? "" : _vm.sysName) + "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.showMenus
            ? [
                _c(
                  "div",
                  { staticClass: "header-box__menu" },
                  [
                    _vm._l(_vm.headerMenus, function(item, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: index,
                            staticClass: "header__item",
                            class: {
                              active:
                                _vm.activeTab === item.url ||
                                +_vm.activeTab === +item.permissionCode
                            },
                            attrs: { id: "item_" + index },
                            on: {
                              click: function($event) {
                                return _vm.handleSelect(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.menuName))]
                        )
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.disabedV2Site
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "isdataauthority",
                            rawName: "v-isdataauthority"
                          }
                        ],
                        staticClass: "header-box__v2",
                        on: {
                          click: function($event) {
                            return _vm.goToV2Version()
                          }
                        }
                      },
                      [_vm._v("\n        返回V2\n      ")]
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showMenus
        ? _c(
            "el-col",
            {
              staticClass: "userinfo",
              attrs: { span: _vm.specialChannel ? 16 : 8 }
            },
            [
              _vm.hongbaoShow
                ? _c(
                    "span",
                    {
                      staticClass: "hongbao",
                      on: {
                        click: function($event) {
                          _vm.activitiesVisible = true
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "badge",
                          attrs: {
                            hidden: _vm.drawsNum ? false : true,
                            value: _vm.drawsNum
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "cloud__image default__image",
                            attrs: {
                              src: require("@/assets/images/hongbao.png"),
                              alt: "",
                              icon: "el-icon-share"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSetting,
                    expression: "hasSetting"
                  }
                ],
                staticClass: "iconfont icon-shezhi1",
                on: { click: _vm.openSetting }
              }),
              _vm._v(" "),
              !_vm.customInfo
                ? _c(
                    "el-dropdown",
                    { attrs: { trigger: "hover", placement: "bottom" } },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "item",
                          attrs: {
                            value: _vm.newCount,
                            max: 99,
                            hidden: !_vm.newCount
                          }
                        },
                        [_c("i", { staticClass: "iconfont icon-kefu6" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "el-dropdown-menu__header",
                          attrs: { slot: "dropdown" },
                          slot: "dropdown"
                        },
                        [
                          _c("div", { staticClass: "message-box" }, [
                            _c(
                              "div",
                              { staticClass: "message-box__item flex flex-b" },
                              [
                                _c("div", { staticClass: "online-KF" }, [
                                  _c("i", { staticClass: "el-icon-headset" }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "message-box__item__text icon-kf__text",
                                      on: { click: _vm.openKF }
                                    },
                                    [
                                      _c(
                                        "el-badge",
                                        {
                                          staticClass: "item badge__kf",
                                          attrs: {
                                            value: _vm.newCount,
                                            max: 99,
                                            hidden: !_vm.newCount
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item_txt" },
                                            [_vm._v("在线客服")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "online-complaint" }, [
                                  _c("i", {
                                    staticClass: "iconfont icon-tousujianyi"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "message-box__item__text icon-kf__text",
                                      on: { click: _vm.openComplaint }
                                    },
                                    [
                                      _c("span", { staticClass: "item_txt" }, [
                                        _vm._v("投诉建议")
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "message-box__item flex" },
                              [
                                _c("i", {
                                  staticClass: "iconfont icon-dianhua"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "message-box__item__text flex flex-d"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("010-86461128（8:30-21:00）")
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "message-box__item flex" },
                              [
                                _c("div", { staticClass: "box__item" }, [
                                  _c("i", {
                                    staticClass: "iconfont icon-erweima"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "message-box__item__text" },
                                    [_vm._v("微信公众号")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "qrcode-box" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/qrcode.jpg"),
                                        alt: ""
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "box__item" }, [
                                  _c("i", {
                                    staticClass: "iconfont icon-erweima"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "message-box__item__text" },
                                    [_vm._v("微信客服")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "qrcode-box" }, [
                                    _c("img", {
                                      staticClass: "qrcode-box__img",
                                      attrs: {
                                        src:
                                          "//f2.youbaolian.top/baksite/resources/img/weixin2.png",
                                        alt: ""
                                      }
                                    })
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "message-box__item flex" },
                              [
                                _c("div", { staticClass: "box__item" }, [
                                  _c("img", {
                                    staticClass: "img-small",
                                    attrs: {
                                      src:
                                        "//f2.youbaolian.top/baksite/resources/img/ashun-small.png",
                                      alt: ""
                                    }
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "message-box__item__text" },
                                    [_vm._v("优保联创始人阿瞬")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "qrcode-box" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "//f2.youbaolian.top/baksite/resources/img/ashun.jpg",
                                        alt: ""
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "box__item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "qrcode-box video-box" },
                                    [
                                      _c("div", [
                                        _vm._v("如果您在使用我们产品或服务时：")
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("❌ 遇到任何迟迟未解决的问题")
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("❌ 心中有任何不吐不快的吐槽")
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            "❌ 有能让产品变得更好的金点子"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("现在，您有了一个直达创始人的"),
                                        _c("span", [_vm._v("“特权窗口”")])
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.customInfo
                ? _c(
                    "el-dropdown",
                    { attrs: { trigger: "hover", placement: "bottom" } },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "el-badge__item",
                          attrs: {
                            value: _vm.unReadCount,
                            hidden: +_vm.unReadCount === 0
                          }
                        },
                        [_c("i", { staticClass: "iconfont icon-gonggao" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "el-dropdown-menu__header",
                          attrs: { slot: "dropdown" },
                          slot: "dropdown"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tab-box" },
                            [
                              _c("header-notice", {
                                attrs: { ejectGZH: _vm.ejectNotice },
                                on: { open: _vm.openNotice, gzh: _vm.openGZH }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { attrs: { trigger: "hover", placement: "bottom" } },
                [
                  _c(
                    "span",
                    { staticClass: "el-dropdown-link userinfo-inner" },
                    [
                      _c("i", { staticClass: "iconfont icon-wode1" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.userInfo &&
                              _vm.loginName + "-" + _vm.userInfo.RealName
                          )
                        )
                      ]),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "el-dropdown-menu__header",
                      style: _vm.getVersionBackground,
                      attrs: { slot: "dropdown" },
                      slot: "dropdown"
                    },
                    [
                      _c("div", { staticClass: "header-box__user" }, [
                        _c(
                          "div",
                          { staticClass: "header-box__user__box" },
                          [
                            _c(
                              "div",
                              { staticClass: "header-box__user__name" },
                              [_vm._v(_vm._s(_vm.loginName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "header-box__user__subdomain" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.userInfo &&
                                      "" + _vm.userInfo.Pratner.subdomain
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(
                              (_vm.userInfo &&
                                _vm.userInfo.CustomerAdditionalRoleVoList) ||
                                [],
                              function(item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.roles,
                                    staticClass: "header-box__user__role"
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(_vm._s(item.rolesName))
                                    ])
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "header-box__user__version" },
                              [
                                _vm.versionBadgeSrc
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.versionBadgeSrc,
                                        alt: ""
                                      },
                                      on: { error: _vm.onVersionBadgeError }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "header-box__user__action" },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "修改资料",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-renyuan1",
                                      on: { click: _vm.changeInfo }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "修改密码",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-bianji iconfont",
                                      on: { click: _vm.changePwd }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "锁屏",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-suoding iconfont",
                                      on: { click: _vm.lockScreen }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "退出",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-tuichu iconfont",
                                      on: { click: _vm.logout }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.dialog.visible,
            title: _vm.dialog.title,
            showFooter: _vm.dialog.step === 2,
            showHeader: _vm.dialog.step !== 2
          },
          on: { close: _vm.close, confirm: _vm.submit }
        },
        [
          _vm.dialog.step === 0
            ? [
                _c("div", { staticClass: "dialog-box__title center" }, [
                  _vm._v(_vm._s(_vm.currentItem.Title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dialog-box__time center" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("dayFormat")(
                        _vm.currentItem.UpdateTime,
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "dialog-box__content",
                  domProps: { innerHTML: _vm._s(_vm.currentItem.Content) }
                })
              ]
            : _vm.dialog.step === 1
            ? _c("div", {
                domProps: { innerHTML: _vm._s(_vm.noticeInfo.Content) }
              })
            : _vm.dialog.step === 2
            ? _c("ybl-browser", { ref: "dialog" })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.dynamic.visible,
            title: _vm.dynamic.title,
            showFooter: false
          },
          on: { close: _vm.close }
        },
        [
          _c(
            "el-carousel",
            { attrs: { interval: 4000, height: "400px" } },
            _vm._l(_vm.dynamic.items, function(item, index) {
              return _c("el-carousel-item", { key: index }, [
                _c("div", {
                  staticClass: "carouse-item__content",
                  domProps: { innerHTML: _vm._s(item.Content) }
                })
              ])
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.remindNotice.visible,
            title: _vm.remindNotice.title,
            showFooter: false
          },
          on: { close: _vm.close }
        },
        [
          _c("ybl-notice-remind", {
            attrs: { dataList: _vm.remindNotice.list }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.activitiesVisible
        ? _c("activities", {
            on: { actEvent: _vm.queryNumberOfLuckyDraw, close: _vm.onHbClose }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 